import React, {useState, useEffect} from 'react';
import {User} from '../states/actions';
import logger from './logger';

export const renderIfAuthenticated = ({component, history}) => {
  // Always check session first to ensure fresh user data
  return (
    <AsyncAuthCheck 
      component={component} 
      history={history} 
    />
  );
};

// Async component to handle authentication check
const AsyncAuthCheck = ({component, history}) => {
  const hasToken = !!localStorage.getItem('sid');
  const [isAuthenticated, setIsAuthenticated] = useState(hasToken);
  const [isLoading, setIsLoading] = useState(!hasToken);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if we have a valid user in session
        let user = await User.getSession();
        if (user) {
          setIsAuthenticated(true);
        } else {
          // Clear any stale data and redirect to login
          localStorage.clear();
          history.push('/login');
        }
      } catch (error) {
        logger.error('Authentication check failed:', error);
        localStorage.clear();
        history.push('/login');
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [history]);

  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  return isAuthenticated ? component : null;
};
